import type { AudioMeta } from "../lib/audioMeta";
import { metaPills } from "../lib/audioMeta";

interface Props {
  bpm?: number;
  musicalKey?: string;
  format?: string;
  meta?: AudioMeta | null;
  loading?: boolean;
  compact?: boolean;
}

export default function AudioMetaStrip({
  bpm,
  musicalKey,
  format,
  meta,
  loading = false,
  compact = false,
}: Props) {
  const pills = metaPills({
    bpm,
    key: musicalKey,
    format,
    meta,
  });

  if (!loading && pills.length === 0) return null;

  return (
    <div className={`audio-meta-strip ${compact ? "compact" : ""}`}>
      {pills.map((pill) => (
        <span className="audio-meta-chip" key={`${pill.label}-${pill.value}`}>
          <em>{pill.label}</em>
          <strong>{pill.value}</strong>
        </span>
      ))}
      {loading ? <span className="audio-meta-chip loading">Reading file details…</span> : null}
    </div>
  );
}
